<template>
  <div>
    <el-dialog
      @close="onClose"
      :visible="modalConfig.visible"
      title="商品信息"
      :close-on-click-modal="false"
      width="1000px"
      @closed="onClosed"
      destroy-on-close
    >
      <div class="text item changepass_content">
        <div class="title-text">活动选择</div>
        <el-form status-icon label-width="100px" class="form-container" size="small">
          <el-form-item label="活动名称">
            <el-select
              style="width: 100%"
              placeholder="请选择活动"
              v-model="actCode"
              filterable
              remote
              :remote-method="remoteMethod"
              clearable
              @change="activityChange"
              :loading="loading"
            >
              <el-option
                v-for="(item, index) in activityList"
                :key="index"
                :value="item.actCode"
                :label="item.actName"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div class="title-text">产品选择</div>
        <div class="goods-container">
          <el-form label-width="100px" v-if="actCode === 'noActivity'">
            <el-row :gutter="20">
              <el-col :span="8">
                <el-form-item label="产品编码">
                  <el-input placeholder="请输入产品编码" v-model="searchData.productCode" clearable></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="产品名称">
                  <el-input placeholder="请输入产品名称" v-model="searchData.productName" clearable></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="search">查询</el-button>
                  <el-button size="small" type="primary" plain icon="el-icon-refresh-right" @click="reset">重置</el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <el-table
            style="width: 100%"
            height="400px"
            :data="goodsData"
            @selection-change="handleSelectionChange"
            v-loading="tableLoading"
            element-loading-spinner="el-icon-loading"
          >
            <el-table-column label="全选" type="selection"></el-table-column>
            <el-table-column
              v-for="(item, index) in table_data_head"
              :key="index"
              :prop="item.prop"
              :label="item.label"
            ></el-table-column>
          </el-table>
        </div>
        <div class="pageschange" v-if="total>pageSize">
          <el-pagination
            background
            layout="total,prev, pager, next"
            :total="total"
            :current-page.sync="pageNum"
            :page-size='pageSize'
            prev-text="上一页"
            next-text="下一页"
            @current-change="getNoActivityGoods()"
          ></el-pagination>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="onClose">
          取 消
        </el-button>
        <el-button :loading="btnLoading" type="primary" size="small" @click="submitFrom">
          确 定
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import request from '@/utils/request'
import { Storage } from '@/utils/storage'
export default {
  props: {
    modalConfig: {
      type: Object,
      default: () => ({
        visible: false,
        data: {}
      })
    }
  },
  data: () => ({
    actCode: '',
    actName: '',
    goodsData: [],
    selectRow: [], //表格选中数据
    table_data_head: [
      { label: '产品编码', prop: 'productCode' },
      { label: '产品名称', prop: 'productName' },
      { label: '产品层级', prop: 'productLevelName' },
      // { label: '重量', prop: 'a' },
      { label: '经销商库存约剩（箱）', prop: 'realTimeStock' },
    ],
    searchData: {}, // 搜索数据
    btnLoading: false,
    loading: false,
    activityList: [{ actCode: 'noActivity', actName: '不参加活动' }], //获取列表
    pageSize: 100,
    pageNum: 1,
    total: 0,
    tableLoading: false,
    actName: '',
    actCode: '',
  }),
  created() {},
  watch: {
    modalConfig: {
      deep: true,
      handler(v) {
        if (v.visible) this.getActivityList()
      }
    }
  },
  methods: {
    // 查询事件
    search(){
      this.getNoActivityGoods(this.searchData)
    },
    // 重置事件
    reset(){
      this.searchData = {}
      this.getNoActivityGoods(this.searchData)
    },
    //表格选择事件
    handleSelectionChange(val) {
      this.selectRow = val
    },
    //关闭弹窗
    onClose() {
      this.$emit('onClose')
    },
    //关闭完成后
    onClosed() {
      this.actCode = ''
      this.actName = ''
      this.goodsData = []
      this.total = 0
      this.pageNum = 1
    },
    //获取远程搜索
    remoteMethod(query) {
      if (query !== '') {
        this.loading = true
        this.getActivityList({ actName: query })
      }
    },
    //获取所有活动
    getActivityList(params = {}) {
      if (!this.modalConfig.data.customerOrgCode) return false
      request
        .post('/tpm/tpmActExpandController/marketGetActPage', {
          ...params,
          customerOrgCode: this.modalConfig.data.customerOrgCode,
          customerCode: Storage.l.get('customerCode')
        })
        .then((res) => {
          if (res.success) {
            this.loading = false
            this.activityList = [{ actCode: 'noActivity', actName: '不参加活动' }, ...res.result.data]
          }
        })
    },
    //不参与活动获取商品
    getNoActivityGoods(params) {
      this.tableLoading = true
      request
        .post('/mdm/p/cus/availableList/list', {
          cusCode: Storage.l.get('customerCode'),
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          ...params
        })
        .then((res) => {
          this.tableLoading = false
          this.total = res.result.count
          this.goodsData = res.result.data.map(item=>{
            item.realTimeStock = item.ext9
            return item
          })
        })
        .catch((err) => {
          this.tableLoading = false
        })
    },
    //参与活动获取商品
    getActivityGoods(params) {
       this.tableLoading = true
      request
        .post('/tpm/tpmActExpandController/marketGetProductByActCode', {
          ...params
        })
        .then((res) => {
          this.tableLoading = false
          this.total = 0
          this.goodsData = res.result.map(item=>{
            item.ext12 = this.actName
            item.ext11 = this.actCode
            return item
          })
        })
        .catch((err) => {
          this.tableLoading = false
        })
    },
    // //商品分页
    // controllerList() {
    //   let params = {
    //     pageNum: this.pageNum,
    //     pageSize: this.pageSize
    //   }
    //   this.getNoActivityGoods(params)
    // },
    //活动change事件
    activityChange(e) {
      this.actCode = e
      if (!e) {
        this.goodsData = []
      }
      if (e === 'noActivity') {
        this.actName = '不参加活动'
        this.actCode = 'noActivity'
        this.getNoActivityGoods()
      }else {
        this.actName = this.activityList.find(item=>item.actCode === e).actName
        this.actCode = e
        const params = {
          actCode: e,
          actName: this.actName,
          customerCode: Storage.l.get('customerCode'),
          customerOrgCode: this.modalConfig.data.customerOrgCode
        }
        this.getActivityGoods(params)
      }
    },
    //提交
    submitFrom() {
      const selectData = this.selectRow.map(item=>({
       productName: item.productName,
       productCode: item.productCode,
      //  productLevelName: item.productLevelName,
       quantity: undefined,
       unitName: item.saleUnitName,
       unit: item.saleUnit,
       price: undefined,
       ext22: undefined,
       ext12: this.actName === '不参加活动'?'':this.actName,
       ext11: this.actCode==='noActivity'?'':this.actCode,
       ext13: item.actDetailCode || '',
       ext21: item.price,
       seriesCode: item.productLevelCode,
       seriesName: item.productLevelName,
       productType: item.productType,
       productTypeName: item.productTypeName,
      //  itmeType: item.itmeType,
      }))
      this.$emit('submit',selectData)
      this.onClose()
    }
  }
}
</script>

<style lang="scss" scoped>
.title-text {
  font-size: 16px;
  line-height: 30px;
  font-weight: 600;
  margin-bottom: 10px;
}
// 分页
.pageschange {
  margin: 20px auto;
  text-align: center;
}
.el-table__body-wrapper::-webkit-scrollbar {
  height: 5px;
}
.el-table__body-wrapper::-webkit-scrollbar-track {
  background-color: #fafafa;
}
.el-table__body-wrapper::-webkit-scrollbar-thumb {
  background: $color-primary;
}
</style>
